export default __webpack_public_path__ + "static/media/partner (2).8c9556b0.png";